<template>
  <v-list-item link @click="$vuetify.goTo(selector.replace(/ /g,''), {duration: 2000})">
    <v-list-item-content :class="accent ? 'primary--text': ''">
      <v-list-item-title>
        <span>{{text}}</span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    text: { type: String },
    selector: { type: String, default: "#" },
    accent: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
</style>